
























































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import SvcRekapRanap, {
  RekapRow,
  RekapWard
} from "@/services/RekapHarianPasienRanap";

/** Baris tabel yang bisa disunting; nama field mengikuti markup blanko. */
interface BarisSensus {
  id: number;
  tanggal: string;
  awal: number;
  masuk: number;
  pindahan: number;
  jumlahIn: number;
  dipindah: number;
  keluarHidup: number;
  jumlahMati: number;
  matiLebih48: number;
  matiKurang48: number;
  jumlahOut: number;
  lamaDirawat: number;
  keluarMasukSamaHari: number;
  sisaDirawat: number;
  vip: number;
  kelas1: number;
  kelas2: number;
  kelas3: number;
  isolasi: number;
  koreksi: RekapRow["koreksi"];
  edited_at: string | null;
  kosong: boolean;
  isEditing: boolean;
  originalData: BarisSensus | null;
}

@Component
export default class RekapHarianTable extends Vue {
  @Prop({ type: Object, required: true }) readonly ward!: RekapWard;
  @Prop({ type: Boolean, default: false }) readonly canEdit!: boolean;
  @Prop({ type: String, default: "" }) readonly bulanLabel!: string;

  rows: BarisSensus[] = [];

  created() {
    this.muat();
  }

  @Watch("ward")
  onWardChanged() {
    this.muat();
  }

  get dapatKoreksi() {
    return this.canEdit;
  }

  muat() {
    const sumber: RekapRow[] = this.ward && this.ward.rows ? this.ward.rows : [];
    this.rows = sumber.map((r: RekapRow) => ({
      id: r.id,
      tanggal: r.tanggal,
      awal: r.awal,
      masuk: r.masuk,
      pindahan: r.pindahan,
      jumlahIn: r.jumlah,
      dipindah: r.dipindah,
      keluarHidup: r.keluar_hidup,
      jumlahMati: r.mati_total,
      matiLebih48: r.mati_ge48,
      matiKurang48: r.mati_lt48,
      jumlahOut: r.jumlah_out,
      lamaDirawat: r.lama_dirawat,
      keluarMasukSamaHari: r.sama_hari,
      sisaDirawat: r.sisa,
      vip: r.sisa_kelas.vip_non,
      kelas1: r.sisa_kelas.k1,
      kelas2: r.sisa_kelas.k2,
      kelas3: r.sisa_kelas.k3,
      isolasi: r.sisa_kelas.iso,
      koreksi: r.koreksi,
      edited_at: r.edited_at,
      kosong: !!r.kosong,
      isEditing: false,
      originalData: null
    }));
  }

  hitungJumlah(item: BarisSensus) {
    const jumlahIn = (item.awal || 0) + (item.masuk || 0) + (item.pindahan || 0);
    const jumlahMati = (item.matiLebih48 || 0) + (item.matiKurang48 || 0);
    const jumlahOut = (item.dipindah || 0) + (item.keluarHidup || 0) + jumlahMati;

    return { jumlahIn, jumlahMati, jumlahOut, sisaDirawat: jumlahIn - jumlahOut };
  }

  editRow(index: number) {
    this.rows[index].originalData = { ...this.rows[index] };
    this.rows[index].isEditing = true;
  }

  cancelRow(index: number) {
    Object.assign(this.rows[index], this.rows[index].originalData);
    this.rows[index].isEditing = false;
  }

  kumpulkanPerubahan(item: BarisSensus) {
    const peta: Record<string, string> = {
      px_awal: "awal",
      px_in: "masuk",
      px_tran_in: "pindahan",
      px_tran_out: "dipindah",
      px_out: "keluarHidup",
      px_dead_gt48: "matiLebih48",
      px_dead_lte48: "matiKurang48",
      los_total: "lamaDirawat",
      px_sameday: "keluarMasukSamaHari",
      vip_total: "vip",
      c1_total: "kelas1",
      c2_total: "kelas2",
      c3_total: "kelas3",
      iso_total: "isolasi"
    };
    const asal: Partial<BarisSensus> = item.originalData || {};
    const fields: Record<string, number> = {};

    Object.keys(peta).forEach(kolom => {
      const baru = Number((item as never as Record<string, number>)[peta[kolom]] || 0);
      if (baru !== Number((asal as Record<string, number>)[peta[kolom]] || 0)) {
        fields[kolom] = baru;
      }
    });

    return fields;
  }

  async saveRow(index: number) {
    const item = this.rows[index];

    if (!item.id) {
      appModule.sendErrorAlert("Baris sensus belum tersimpan di server. Tekan Tampilkan lagi.");

      return;
    }

    const fields = this.kumpulkanPerubahan(item);

    if (Object.keys(fields).length === 0) {
      item.isEditing = false;

      return;
    }

    try {
      const ward = await SvcRekapRanap.updateKoreksi(item.id, fields);
      this.$emit("updated", ward);
      appModule.sendSuccessNotice("Perubahan data sensus berhasil disimpan.");
    } catch (error) {
      // ErrorAlert sudah ditampilkan di service.
    }
  }

  tanggalHari(val: string) {
    if (!val) return "";

    return parseInt(val.split("-")[2], 10);
  }

  formatTanggalJam(tgl: string) {
    if (!tgl) return "";

    return moment(tgl).format("DD-MM-YYYY HH:mm:ss");
  }

  jumlahkan(key: string): number {
    return this.rows.reduce(
      (t: number, r: BarisSensus) => t + ((r as never as Record<string, number>)[key] || 0),
      0
    );
  }

  get totalAwal() { return this.jumlahkan("awal"); }
  get totalMasuk() { return this.jumlahkan("masuk"); }
  get totalPindahan() { return this.jumlahkan("pindahan"); }
  get totalDipindah() { return this.jumlahkan("dipindah"); }
  get totalKeluarHidup() { return this.jumlahkan("keluarHidup"); }
  get totalLebih48() { return this.jumlahkan("matiLebih48"); }
  get totalKurang48() { return this.jumlahkan("matiKurang48"); }
  get totalLamaDirawat() { return this.jumlahkan("lamaDirawat"); }
  get totalHariSama() { return this.jumlahkan("keluarMasukSamaHari"); }
  get totalKelasVIP() { return this.jumlahkan("vip"); }
  get totalKelas1() { return this.jumlahkan("kelas1"); }
  get totalKelas2() { return this.jumlahkan("kelas2"); }
  get totalKelas3() { return this.jumlahkan("kelas3"); }
  get totalIsolasi() { return this.jumlahkan("isolasi"); }

  get totalMasukPindahanAwal() { return this.totalAwal + this.totalMasuk + this.totalPindahan; }
  get totalMati() { return this.totalLebih48 + this.totalKurang48; }
  get totalJumlahKeluar() { return this.totalDipindah + this.totalKeluarHidup + this.totalMati; }
  get totalSisaDirawat() { return this.rows.reduce((t: number, r: BarisSensus) => t + this.hitungJumlah(r).sisaDirawat, 0); }
}
